module.exports = __webpack_public_path__ + "static/media/reset-clarnium.817a0a7f.svg";